'use client';
import { useRouter } from "next/navigation";
import React from "react";

const ButtonLihat = () => {
  const router = useRouter();

  return (
    <button
      data-prefetch-path="/daftar-aplikasi"
      onClick={() => router.push("/daftar-aplikasi")}
      type="button"
      className="btn btn-primary"
    >
      Lihat
    </button>
  );
};

export default ButtonLihat;
